<template>
  <Tooltip theme="light" placement="top">
    <template #content>
      <span class="tooltip-title">{{ alt }}</span>
    </template>

    <div class="image-selector" :class="{ selected: isSelected }" @click="handleClick">
      <img :src="imageSrc" :alt="alt" class="image" width="108" height="108" />
      <div v-if="isSelected" class="selected-overlay" :class="innerBorderClass"></div>
    </div>
  </Tooltip>
</template>

<script setup lang="ts">
import Tooltip from '@rendora/design/components/tooltip/Tooltip.vue';

defineProps({
  imageSrc: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  innerBorderClass: {
    type: String,
    required: false,
    default: 'box-black',
  },
});

const emit = defineEmits(['select']);

const handleClick = () => {
  emit('select');
};
</script>

<style lang="scss" src="./styles/image.pc.scss" />
<style lang="scss" src="./styles/image.mobile.scss" />
